<template>
    <div class="leftcolumn">
        <div class="card">
            <h2>My Exceperinse in Podcasing</h2>
            <div class="fakeimg" style="height: 200px">Image</div>
            <p>Coming soon...</p>
        </div>
    </div>
</template>